import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';


import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import zIndex from '@mui/material/styles/zIndex.js';


export default function TeacherCourseMapping() {

    const [admissionYears, setAdmissionYears] = useState([]);
    const [admissionYear, setAdmissionYear] = useState(null);
    const [activeSemester, setActiveSemesterId] = useState(null);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [issaved, setissaved] = useState(false);
    const [semester_id, setSemester] = useState([]);

    const [selectedUserOptions, setSelectedUserOptions] = useState({});
    const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
    const [isFirstSubmit, setFirstSubmit] = useState(false);
    const [facultyMap, setFacultyMap] = useState({});

    const [tableData, setTableData] = useState([]);
    const [isolist, setIsolist] = useState([]);
    const [iso, setISO] = useState(false);
    const [isofilter, setISOfilter] = useState(false);
    const [ShowModal, setShowModal] = useState(false);

    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [selectedStudents, setSelectedStudents] = useState([]);


    const [disciplineId, setDisciplineChange] = useState(null);
    const [disciplinetype, setDisciplineTypeChange] = useState(null);
    const [disciplineName, setDisciplineNameChange] = useState(null);



    const { http } = Api();
    const navigate = useNavigate();

    const isAuth = useAuth();

    if (isAuth === false) {

        navigate("/ino/");
    }

    let cid = localStorage.getItem("collegeid");

    useEffect(() => {
        const fetchActiveEvents = async () => {

            if (admissionYear?.value && semester_id?.value) {

                try {

                    const response = await http.get('getActiveEvents', {
                        params: { event_id: 30 }
                    });

                    const matchedEvent = response.data.find(event =>
                        event.admission_year === admissionYear.value &&
                        event.semester_id === semester_id.value &&
                        event.status === "active"
                    );

                    if (matchedEvent) {
                        setActiveSemesterId(matchedEvent.semester_id); // store active semester

                    } else {

                        setActiveSemesterId(null);
                    }
                } catch (error) {

                    setActiveSemesterId(null);


                }

            } else {

                setActiveSemesterId(null);

            }

        };

        fetchActiveEvents();
    }, [admissionYear, semester_id]);

    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {

                const response = await http.get('/College/getSFASideActiveAdmissionYear');
                const years = response.data
                    .filter(year => year.admission_year !== 2025)
                    .map((year) => ({
                        id: year.id,
                        value: year.admission_year,
                        label: year.admission_year
                    }));

                setAdmissionYears(years);
            } catch (error) {

                setAdmissionYears([]);

                toast.error("Error fetching admission years");
            }
        };
        fetchAdmissionYears();
    }, []);

    const handleAdmissionYearChange = (selectedOption) => {

        setAdmissionYear(selectedOption);
        setDisciplineChange([]);
        setDisciplineTypeChange(null);
        setDisciplineNameChange(null);

    };

    const handleSemesterChange = (selectedOption) => {

        setSemester(selectedOption);
        setDisciplineChange([]);
        setDisciplineTypeChange(null);
        setDisciplineNameChange(null);

    };

    const handleDisciplineChange = (selectedOption) => {

        setDisciplineChange(selectedOption.did);
        setDisciplineNameChange(selectedOption.value);
        setDisciplineTypeChange(selectedOption.type);
    };


    useEffect(() => {

        const fetchData = async () => {

            try {
                const response = await http.get(`/College/getCollegeDisciplinesforINO`, {

                    params: {
                        college_id: cid,
                        semester_id: semester_id.value,
                        admission_year: admissionYear.value,
                    }
                });

                if (!(response?.data?.status_code === 'ERR5')) {
                    setDisciplineData(response.data);
                }
            }
            catch (error) {

                toast.error("Error fetching disciplines");
            }
        };

        if (admissionYear?.value && semester_id?.value) {

            fetchData();

        }

    }, [admissionYear, semester_id, issaved]);

    // useEffect(() => {
    //   const getCourseMappingStatusSummary = async () => {

    //     http.get('/College/getCourseMappingStatusSummary', {
    //       params: {

    //         college_id: cid,
    //         admissionyear: admissionYear.value,
    //         semester_id: semester_id.value,

    //       },
    //     }).then((response) => {

    //       setCourseMappingStatusSummaryData(response.data);

    //     }).catch((error) => {

    //       setCourseMappingStatusSummaryData([]);

    //     });
    //   };
    //   if (cid && admissionYear && semester_id.value) {

    //     getCourseMappingStatusSummary();
    //   }


    // }, [admissionYear, semester_id.value, issaved]);


    useEffect(() => {

        const fetchCollegeTeachersList = async () => {


            try {

                const params = {
                    discipline_id: disciplineId,
                    admission_year: admissionYear?.value,
                    coursetype: disciplinetype,
                };

                // add only if iso has value
                if (isofilter) {

                    params.fac_id = isofilter;
                }

                const response = await http.get('/College/viewStudentListINO', {
                    params: params,
                });


                setTableData(response.data.studentlist);
                setSelectedStudents([]);


            } catch (error) {

                setTableData([]);
                setSelectedStudents([]);

            }
        };

        if (disciplinedata.length > 0) {

            fetchCollegeTeachersList();
        }

    }, [disciplineName, issaved, isofilter]);


    useEffect(() => {

        const fetchCollegeTeachersList = async () => {


            try {
                const response = await http.get('/College/ListIso', {
                    params: {

                        discipline_id: disciplineId,
                        admission_year: admissionYear?.value,
                        coursetype: disciplinetype,
                    },
                });


                setIsolist(response.data.data);


            } catch (error) {

                setIsolist([]);


            }
        };



        fetchCollegeTeachersList();


    }, [disciplineName, issaved]);




    const handlefirstsubmit = () => {

        setFirstSubmit(!isFirstSubmit);

    }

    const handleISOChangeapi = (e) => {

        if (!e) {
            setISOfilter(false);
            return;
        }
        setISOfilter(e.value);

    }

    const handleISOChange = (e) => {

        setISO(e.value);

    }


    const handleSubmitData = (e) => {

        e.preventDefault();


        const saveUserDataForSeat = () => {

            http.post('/College/StudentIsoMapping', {



                students: selectedStudents,
                iso: iso,
                discipline_id: disciplineId



            }).then((response) => {

                if (response.data.status_code === 'MSG1') {

                    setissaved(!issaved);
                    setShowModal(false);
                    setSelectedStudents([]);
                    setIsSelectAllChecked(!isSelectAllChecked);
                    toast.success('Data saved successfully');



                } else {
                    toast.error('Failed to save data');
                    setissaved(!issaved);


                }
            }).catch((error) => {

                toast.error("Something went wrong");

            });
        };

        saveUserDataForSeat();

    };


    const handleRemoveStudent = (accountid, fac_uid) => {


        const RemoveStudent = () => {

            http.post('/College/deleteIsoMapping', {

                accountid: accountid,
                fac_uid: fac_uid



            }).then((response) => {

                if (response.data.status_code === 'MSG1') {

                    setissaved(!issaved);
                    setShowModal(false);
                    setSelectedStudents([]);
                    setIsSelectAllChecked(!isSelectAllChecked);
                    toast.success('mapping removed successfully');

                } else {
                    toast.error('Mapping not found or already deleted');
                    setissaved(!issaved);


                }
            }).catch((error) => {

                toast.error("Mapping not found or already deleted");

            });
        };

        RemoveStudent();

    };

    const handleCancel = () => {

        setFirstSubmit(!isFirstSubmit);
        //window.location.reload();
    }


    const handleGeneratePDFNew = async () => {
        // setLoading(true);
        try {
            const response = await http.get('/College/disciplineISPdfDownload', {
                params: {
                    college_id: cid,
                    admissionyear: admissionYear.value,
                    semester_id: semester_id.value,
                    discipline_id: disciplineId,
                    coursetype: disciplinetype,
                },
                responseType: 'blob', // Expect binary response
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute(
                    'download',
                    `${localStorage.getItem('username')}__Discipline_IS_Mapping - .pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // setLoading(false);
                toast.success('PDF generated successfully');
            }
        } catch (error) {

            toast.error('Error generating PDF');

        }
    };

    const handleCheckboxChange = (apaarId) => {

        if (selectedStudents.includes(apaarId)) {
            // Deselect the student
            const student = selectedStudents.filter(id => id !== apaarId)
            setSelectedStudents(student);

            if (student.length === 0) {
                setIsSelectAllChecked(false);
            }

        } else {
            // Select the student
            setSelectedStudents([...selectedStudents, apaarId]);
        }
    };

    const handleSelectAll = () => {

        const allSelected = !isSelectAllChecked;
        setIsSelectAllChecked(allSelected);

        if (allSelected) {
            // Select all students' apaarId
            const allStudentIds = tableData
                .filter((studentDetails) => studentDetails?.iso_student == 'not mapped')
                .map((studentDetails) => studentDetails?.accountid);
            setSelectedStudents(allStudentIds);

        } else {
            // Deselect all
            setSelectedStudents([]);
        }
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            textAlign: 'left', // added

        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '180px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
            textAlign: 'left', // added

        }),

        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
                textAlign: 'left', // added

            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="table-responsive">
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center">
                                            <h5>Internship Supervisor - Student Mapping </h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div className="card-body">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-12 mb-4">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label>Admission Year <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="admyear"
                                                                    name="admyear"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={admissionYears}
                                                                    value={admissionYear}
                                                                    onChange={handleAdmissionYearChange}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label>Semester <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="semester_id"
                                                                    name="semester_id"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={[
                                                                        { value: 4, label: '4' },
                                                                        // { value: 5, label: '5' }
                                                                    ]}
                                                                    value={semester_id}
                                                                    onChange={handleSemesterChange}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label>Discipline <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="discipline_id"
                                                                    name="discipline_id"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    onChange={handleDisciplineChange}
                                                                    options={disciplinedata.length === 0
                                                                        ? [{ value: '0', label: 'No data found' }]
                                                                        : disciplinedata
                                                                            .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                            .map(disciplines => ({
                                                                                did: disciplines.discipline_id,
                                                                                value: disciplines.discipline_name,
                                                                                label: disciplines.discipline_name,
                                                                                type: disciplines.college_course_type
                                                                            }))
                                                                    }
                                                                    value={
                                                                        disciplinedata
                                                                            .map(d => ({
                                                                                did: d.discipline_id,
                                                                                value: d.discipline_name,
                                                                                label: d.discipline_name,
                                                                                type: d.college_course_type
                                                                            }))
                                                                            .find(option => option.value == disciplineName) || null
                                                                    }
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                {/* <div className="row g-sm-3 height-equal-2 widget-charts">

                        
                                                        <div className="col-sm-4">
                                                            <div className="card small-widget mb-sm-0 bod-line">
                                                            <div className="card-body primary"> <span className="f-light">Total Courses</span>
                                                                <div className="d-flex align-items-end gap-1">
                                                                <h5>{getCourseMappingStatusSummaryData.total_courses ? getCourseMappingStatusSummaryData.total_courses : '0'}</h5>
                                                                </div>
                                                                <div className="bg-gradient">
                                                                <svg className="stroke-icon svg-fill">
                                                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                                                </svg>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-4">
                                                            <div className="card small-widget mb-sm-0 bod-line">
                                                            <div className="card-body primary"> <span className="f-light">Mapped Courses</span>
                                                                <div className="d-flex align-items-end gap-1">
                                                                <h5>{getCourseMappingStatusSummaryData.mapped_courses ? getCourseMappingStatusSummaryData.mapped_courses : '0'}</h5>


                                                                </div>
                                                                <div className="bg-gradient">
                                                                <svg className="stroke-icon svg-fill">
                                                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                                                </svg>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-4">
                                                            <div className="card small-widget mb-sm-0 bod-line">
                                                            <div className="card-body primary"> <span className="f-light">Mapping Pending Courses</span>
                                                                <div className="d-flex align-items-end gap-1">
                                                                <h5>{getCourseMappingStatusSummaryData.pending_courses ? getCourseMappingStatusSummaryData.pending_courses : '0'}</h5>

                                                                </div>
                                                                <div className="bg-gradient">
                                                                <svg className="stroke-icon svg-fill">
                                                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                                                </svg>
                                                                </div>
                                                            </div>
                                                            </div>

                                                        </div>
                                                        </div> */}

                                                <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>

                                                    <div className="row mt-2 align-items-end">

                                                        {/* LEFT SIDE BUTTON */}
                                                        <div className="col-md-8 d-flex align-items-center gap-3">
                                                            {selectedStudents.length > 0 && (
                                                                <button
                                                                    className="btn btn-primary"
                                                                    type="button"
                                                                    onClick={() => setShowModal(true)}
                                                                >
                                                                    Map Selected Students
                                                                </button>
                                                            )}

                                                            {Array.isArray(tableData) && tableData.length > 0 && (

                                                                <button
                                                                    className="lbl2 btn btn-primary"
                                                                    onClick={() => handleGeneratePDFNew()}
                                                                    title="Download"
                                                                >
                                                                    <i className="bi bi-arrow-down-square"></i>
                                                                </button>
                                                            )}
                                                        </div>


                                                        {/* RIGHT SIDE FILTER */}
                                                        <div className="col-md-4 text-end">

                                                            <Select
                                                                maxMenuHeight={200}
                                                                menuPlacement="auto"
                                                                className="form"
                                                                styles={customStyles}
                                                                placeholder="Filter Supervisor..."
                                                                isClearable   // <-- THIS ADDS REMOVE (X) BUTTON
                                                                onChange={(e) => handleISOChangeapi(e)}
                                                                options={
                                                                    isolist.length === 0
                                                                        ? [{ value: '0', label: 'No data found' }]
                                                                        : isolist
                                                                            .sort((a, b) => a.fac_name.localeCompare(b.fac_name))
                                                                            .map(item => ({
                                                                                value: item.fac_pk,
                                                                                label: item.fac_name,
                                                                            }))
                                                                }
                                                            />
                                                        </div>

                                                    </div>




                                                    <div class="table-container mt-1">
                                                        <table className="display dataTable table-striped table-bordered" id="dataTable">
                                                            <thead>
                                                                <tr className="bg-primary" >

                                                                    <th scope="col" width="8%">
                                                                        {Array.isArray(tableData) && tableData.length > 0 && tableData.some(row => row.iso_student == 'not mapped') && (
                                                                            <input id="select-all" type="checkbox"
                                                                                onChange={handleSelectAll}
                                                                                checked={isSelectAllChecked} />
                                                                        )}

                                                                    </th>
                                                                    <th scope="col" width="8%">Sl NO</th>
                                                                    <th scope="col" width="20%">PRN</th>
                                                                    <th scope="col" width="20%">Name</th>
                                                                    <th scope="col" width="12%">Mapped To</th>
                                                                    <th scope="col" width="12%">Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData.length > 0 ? (
                                                                    tableData.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {row.iso_student == 'not mapped' ? (
                                                                                    <input type="checkbox" class="text-center" value={row.accountid}
                                                                                        checked={selectedStudents.includes(row.accountid)}
                                                                                        onChange={() => handleCheckboxChange(row.accountid)} />
                                                                                ) : (

                                                                                    <span class="badge badge-success text-white rounded-pill"><i class="fa fa-check" aria-hidden="true"></i></span>


                                                                                )}
                                                                            </td>
                                                                            <td>{index + 1}</td>
                                                                            <td>{row.PRN}</td> {/* Replace 'column1' with actual response keys */}
                                                                            <td>{row.studentname}</td>
                                                                            <td className={row.faculty_name ? 'status-present' : 'status-absent'}>

                                                                                {row.faculty_name ? row.faculty_name : "Not yet mapped"}

                                                                            </td>
                                                                            <td className={

                                                                                row.iso_student === 'mapped' ? 'status-present' : row.iso_student === 'approved' ? 'status-present' : 'status-absent'

                                                                            }>
                                                                                {row.iso_student === 'mapped' ? ' Forwarded to Principal' : row.iso_student === 'approved' ? 'Mapping Approved' : 'Not yet mapped'}
                                                                            </td>

                                                                            {/* <td className="text-center">
                                                                                {/* {row.iso_student === 'mapped' ? (
                                                                                    // <button
                                                                                    //     type="button"
                                                                                    //     className="btn btn-outline-warning btn-sm rounded-pill px-3"
                                                                                    //     onClick={() => handleRemoveStudent(row.accountid, row.fac_uid)}
                                                                                    //     title="Edit Student"
                                                                                    // >
                                                                                    //     <i className="fa fa-edit me-1" aria-hidden="true"></i>
                                                                                    //     Edit
                                                                                    // </button>
                                                                                    -
                                                                                ) :
                                                                                {row.iso_student === 'approved' ? (

                                                                                    <span className="badge badge-success text-white rounded-pill">
                                                                                        <i className="fa fa-check me-1" aria-hidden="true"></i>
                                                                                        Principal Approved
                                                                                    </span>

                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td> */}

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="7">No data available</td>
                                                                    </tr>
                                                                )}


                                                            </tbody>
                                                        </table>

                                                        <div className="col-md-12 txt-aln p-50">
                                                            <div>
                                                                {selectedStudents.length > 0 && (
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        type="button"
                                                                        onClick={() => setShowModal(true)}
                                                                    >
                                                                        Map Selected Students
                                                                    </button>
                                                                )}


                                                            </div>
                                                        </div>




                                                    </div>

                                                    {ShowModal && (
                                                        <div className="college-fee-part">
                                                            <div className="fee-overlay" onClick={() => setShowModal(false)}>

                                                                <div className="fee-modal" onClick={(e) => e.stopPropagation()}>

                                                                    {/* ===== HEADER ===== */}
                                                                    <div className="fee-modal-header">
                                                                        <h4>Internship Supervisor</h4>
                                                                        <button
                                                                            className="fee-close-btn"
                                                                            onClick={() => setShowModal(false)}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>

                                                                    {/* ===== BODY ===== */}
                                                                    <div className="fee-modal-body p-3 ">

                                                                        {/* ===== TABLE CARD ===== */}
                                                                        <div className="card shadow-sm mb-4 p-3">




                                                                            <table className="table table-bordered table-hover modern-table">
                                                                                <thead className="table-light">
                                                                                    <tr>
                                                                                        <th width="10%">Sl. No.</th>
                                                                                        <th width="60%">Internship Supervisor</th>
                                                                                        <th width="30%">Mapped Count</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    {isolist?.map((item, index) => (
                                                                                        <tr key={index}>
                                                                                            <td>{index + 1}</td>
                                                                                            <td>{item.fac_name}</td>
                                                                                            <td>{item.student_count}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>


                                                                        </div>

                                                                        {/* ===== SELECT CARD ===== */}
                                                                        <div className="card shadow-sm mb-6">
                                                                            <div className="card-body">

                                                                                <label className="form-label mb-2">
                                                                                    Select Internship Supervisor <span className="errorclr">*</span>
                                                                                </label>

                                                                                <Select
                                                                                    maxMenuHeight={200}
                                                                                    menuPlacement="auto"
                                                                                    className="form"
                                                                                    styles={customStyles}
                                                                                    placeholder="Choose Supervisor..."
                                                                                    onChange={(e) => handleISOChange(e)}
                                                                                    options={
                                                                                        isolist.length === 0
                                                                                            ? [{ value: '0', label: 'No data found' }]
                                                                                            : isolist
                                                                                                .sort((a, b) => a.fac_name.localeCompare(b.fac_name))
                                                                                                .map(item => ({
                                                                                                    value: item.fac_pk,
                                                                                                    label: item.fac_name,
                                                                                                }))
                                                                                    }
                                                                                />

                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    {/* ===== FOOTER ===== */}
                                                                    <div className="fee-modal-footer d-flex justify-content-end gap-3 p-3 border-top">

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success px-4"
                                                                            onClick={handleSubmitData}
                                                                            disabled={!iso || selectedStudents.length === 0}
                                                                        >
                                                                            Forwarded TO Principal( {selectedStudents.length} Students)
                                                                        </button>

                                                                        <button
                                                                            className="btn btn-outline-secondary px-4"
                                                                            onClick={() => setShowModal(false)}
                                                                        >
                                                                            Close
                                                                        </button>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}


                                                    {/* <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                                            <div className="modal-content">
                                                                <div className="modal-body">
                                                                    <div className="modal-toggle-wrapper">
                                                                        <h4 className="text-center pb-2">Are you sure you want to save?</h4>
                                                                        <p className="txt-aln-jst">Please note that only courses mapped to a teacher in the SFA Panel will be available for students during course selection.</p>
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <div>
                                                                                <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Save</button>
                                                                                <button
                                                                                    className="btn"
                                                                                    style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                                                    data-bs-dismiss="modal"
                                                                                    onClick={handleCancel}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </Template>
        </>
    );
}
